import { createFileRoute } from '@tanstack/react-router'
import { RenewalsPage } from '../../features/renewals'
import { RenewalsAccessGuard } from './-renewalsAccess'

export const Route = createFileRoute('/_authenticated/renewals')({
  component: RenewalsRoute,
})

function RenewalsRoute() {
  return (
    <RenewalsAccessGuard>
      <RenewalsPage />
    </RenewalsAccessGuard>
  )
}
